import RMain from './Components/Rotator/RMain'
function App() {
  return (
    <div style={{ backgroundColor: 'rgb(70, 70, 70)' }}>
      <RMain />
    </div>
  )
}
export default App
